module.exports = __webpack_public_path__ + "static/media/angle-left.92830189.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DashboardFiles/icons/angle-left.svg
 ** module id = 321
 ** module chunks = 0
 **/